import { rgbAlpha } from '@/styles'
import { FC, useRef } from 'react'
import { type RegisterOptions, type UseFormRegister } from 'react-hook-form'
import styled from 'styled-components'

type Props = {
  defaultChecked?: boolean
  disabled?: boolean
  id?: string
  label: string
  name: string
  textColor?: string
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
  register: UseFormRegister<any>
  required?: boolean
  dataHidden?: boolean
  value?: string
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void
}

const SvgCircle = ({ textColor }) => {
  return <svg viewBox='0 0 10 10' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='5' cy='5' r='4.75' stroke={textColor} strokeWidth='0.5' fill='none' />
  </svg>
}

export const InputRadio: FC<Props> = ({ defaultChecked, disabled, id, label, name, register, required, textColor = 'var(--color-text)', value, onClick, dataHidden }) => {
  const requireProps: RegisterOptions = { required }
  const {
    name:registerName,
    onChange:registerOnChange,
    onBlur: registerOnBlur,
    ref:registerRef
  } = register(name, requireProps)
  const ref = useRef<HTMLInputElement | null>(null)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    registerOnChange?.(e)
  }

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    registerOnBlur?.(e)
  }

  return (
    <Label $textColor={textColor} $disabled={disabled} $dataHidden={dataHidden}>
      <input
        ref={e => {
          ref.current = e
          registerRef?.(e)
        }}
        type='radio'
        name={registerName ?? name}
        onChange={handleChange}
        onBlur={handleBlur}
        onClick={onClick}
        value={value}
        {...id ? { id } : {}}
        {...defaultChecked ? { defaultChecked } : {}}
        {...disabled ? { disabled } : {}}
      />
      <SvgCircle textColor={textColor} />
      <span>{label}</span>
    </Label>
  )
}

const Label = styled.label<{ $textColor: string, $disabled: boolean, $dataHidden: boolean }>`
  color: ${({ $textColor }) => $textColor};
  cursor: pointer;
  display: ${({ $dataHidden }) => $dataHidden ? 'none' : 'block'};
  pointer-events: ${({ $disabled }) => $disabled ? 'none' : 'auto'};


  input {
    opacity: 1;
    position: absolute;
    user-select: none;
    visibility: hidden;

    + svg {
      margin-right: 5px;

      circle {
        fill: ${rgbAlpha('--color-text', 0)};
        transition: 250ms fill linear;
      }
    }

    &:checked {
      + svg {
        circle {
          fill: ${({ $textColor }) => $textColor};
        }
      }
    }

    &:disabled,
    &[disabled='true'] {
      pointer-events: none;

      + svg,
      ~ span {
        opacity: .4;
      }
    }
  }

  svg {
    height: 10px;
    width: 10px;
  }
`
